import { useEffect, useState } from "react";

const QUERY = "(max-width: 767px)";

/** True below Tailwind's `md` breakpoint. Re-evaluates on resize/rotation. */
export function useIsMobile() {
  const [mobile, setMobile] = useState(() => typeof window !== "undefined" && window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return mobile;
}

/** Horizontal swipe detection for touch screens. Returns handlers to spread on an element. */
export function useSwipe(onSwipe, { threshold = 60, maxVertical = 50 } = {}) {
  const [start, setStart] = useState(null);
  return {
    onTouchStart: (e) => {
      const t = e.touches[0];
      setStart({ x: t.clientX, y: t.clientY });
    },
    onTouchEnd: (e) => {
      if (!start) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - start.x;
      const dy = t.clientY - start.y;
      setStart(null);
      if (Math.abs(dx) >= threshold && Math.abs(dy) <= maxVertical) onSwipe(dx < 0 ? "left" : "right");
    },
  };
}
